/**
 * AzureLogo/index.js
 * desc: Azure product logo
 * note: renders an accessible button (aria-label) when given an onClick handler; otherwise a static figure
 */
'use strict';

import IconButton from '../IconButton';


const AzureLogo = (props) => (
    <IconButton baseClassName="azure logo" label="Azure" tooltip={ null } { ...props }>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fillRule="evenodd"><path fill="#035bda" d="M19.867 7.282l-4.733 9.533 8.333 9.66L8 28.23l24 .25zm-.934-3.762L8.067 12.613 0 26.223l6.867-.7z"/></svg>
    </IconButton>
);


export default AzureLogo;
